export const SALESDATAFETCHED = 'SALESDATAFETCHED'
export const SALESTRANSACTIONDATAFETCHED = 'SALESTRANSACTIONDATAFETCHED'
export const SALESTRANSACTIONTABLEDATAFETCHED = 'SALESTRANSACTIONTABLEDATAFETCHED'

export const LOADINGSALESTRANSACTIONCHARTDATA = 'LOADINGSALESTRANSACTIONCHARTDATA'
export const SETLOADINGSALESVOLUMECHARTDATA = 'SETLOADINGSALESVOLUMECHARTDATA'
export const SETLOADINGSALESDISPUTECHARTDATA = 'SETLOADINGSALESDISPUTECHARTDATA'

export const SETSALESTRANSACTIONCHARTDATA = 'SETSALESTRANSACTIONCHARTDATA'
export const SETSALESVOLUMECHARTDATA = 'SETSALESVOLUMECHARTDATA'
export const SETSALESDISPUTECHARTDATA = 'SETSALESDISPUTECHARTDATA'

export const SALESVOLUMEDATAFETCHED = 'SALESVOLUMEDATAFETCHED'
export const SALESVOLUMETABLEDATAFETCHED = 'SALESVOLUMETABLEDATAFETCHED'
export const SALESCUSTOMERDATAFETCHED = 'SALESCUSTOMERDATAFETCHED'
export const SALESDISPUTESDATAFETCHED = 'SALESDISPUTESDATAFETCHED'
export const SALESDISPUTETABLEDATAFETCHED = 'SALESDISPUTETABLEDATAFETCHED'
export const SALESTABLEDATAFETCHED = 'SALESTABLEDATAFETCHED'

export const LOADINGSALESCHARTDATA = 'LOADINGSALESCHARTDATA'

export const LOADINGSALESDATA = 'LOADINGSALESDATA'
export const SETLOADINGSALESTABLEDATA = 'SETLOADINGSALESTABLEDATA'

export const SETSALESOVERVIEWDAYSPAN = 'SETSALESOVERVIEWDAYSPAN'
